<template>
	<div class="yearContent">
        <keep-alive exclude="yearDetail">
            <router-view />
        </keep-alive>
		<to-top></to-top>
	</div>
</template>

<script>
import toTop from '@/components/to-top'
export default {
    name: 'yearContent',
    components: {
		toTop
	}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/year-content/index.vue